// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__cpxLN","choiceBoxes":"toolbarselects_choiceBoxes__3ugtu","simpleField":"toolbarselects_simpleField__3km4G"};